import { render, staticRenderFns } from "./talentInfo.vue?vue&type=template&id=6a211cac&scoped=true"
import script from "./talentInfo.vue?vue&type=script&lang=js"
export * from "./talentInfo.vue?vue&type=script&lang=js"
import style0 from "./talentInfo.vue?vue&type=style&index=0&id=6a211cac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a211cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a211cac')) {
      api.createRecord('6a211cac', component.options)
    } else {
      api.reload('6a211cac', component.options)
    }
    module.hot.accept("./talentInfo.vue?vue&type=template&id=6a211cac&scoped=true", function () {
      api.rerender('6a211cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/talentInfo.vue"
export default component.exports